import React, { useEffect, useState, useContext, useRef, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ACTIONS, AuthRoutes, SELECTED_TAB_KEY, TOAST_TYPE, USERTYPES } from "../../constants/Constants";
import { useTranslation } from "react-i18next";
import { getPacsQueueList, refreshQueueItem, cancelQueueItem, swapQueueItemPriority } from "../../service/PacsQueueService";
import { t } from "i18next";
import ListViewV3 from "../../components/ListViewV3/ListViewV3";
import userContext from "../../context/users/UserContext";
import toastContext from "../../context/toast/ToastContext";
import { Dropdown, PrimaryButton, SearchBox, TextField, DatePicker } from "@fluentui/react";
import loaderContext from "../../context/loader/LoaderContext";
import ColumnsAIRequest from "./ColumnsAIRequest";
import { aiResultsInitialState, sendingStatusOptions, responseStatusOptions } from "./Helper";
import { getAiRequestList, aiExportCsvFetchProgress, aiExportCsvDownloadFile } from "../../service/AIRequestsService";
import AiExportCsvModal from "./components/ExportCsv/AiExportCsvModal";
import CustomMultiSelect from "../../components/CustomMultiSelect";


const AIRequestList = (props) => {
  const [t] = useTranslation();
  const { roles, loadByUsername, authenticated, exportCsvAllowed } = useContext(userContext);
  const { showToastv2, showProgressToast, updateProgress, hideProgress } = useContext(toastContext);
  const [ dataQueryState, setDataQueryState ] = useState({});
  const [ displayListAppliedFilter, setDisplayListAppliedFilter ] = useState([]);
  const [ aiRequestsFilterObj, setAiRequestsFilterObj ] = useState(aiResultsInitialState);
  const { setLoaderRunning, ref } = useContext(loaderContext);
  const [ paginationObj, setPagination ] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const [ filterObj, setFilterObj ] = useState({
    filterInput: null,
    filterUpdate: 0,
  });
  const [ isInitialCall, setIsInitialCall ] = useState(true);
  const [ status, setStatus ] = useState([]);
  const [ showAiExportCsvModal, setShowAiExportCsvModal ] = useState(false);
  const [ aiExportProgress, setAiExportProgress ] = useState(0);
  const [ aiExportProgressId, setAiExportProgressId ] = useState(0);
  const [ aiExportToken, setAiExportToken ] = useState("");
  const [ aiExportFetchInterval ] = useState(2000);
  const aiExportPollIntervalRef = useRef(null);
  const [clientOptions, setClientOptions] = useState([]);
  const [destinationFilterOptions, setDestinationFilterOptions] = useState([]);
 // const [ listViewLoading,setListViewLoading ] = useState(false);
 // const listViewRef = useRef(null);

  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
    }
  }, []);

  // Auto-refresh logic
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     ReloadList();
  //   }, 15000); 
  //   return () => clearInterval(interval);
  // }, []);
  

  useEffect(() => {
    console.log("isInitialCall:", isInitialCall);
  
    if (isInitialCall) {
      setIsInitialCall(false); 
    } else {
      setAiRequestsFilterObj(aiResultsInitialState);
      setDisplayListAppliedFilter([]);
      setPagination(() => {
        const newItem = { ...paginationObj };
        newItem.pageIndex = 0;
        return newItem;
      });

      setTimeout(() => {
        setFilterObj(() => {
          const newItem = { ...filterObj };
          newItem.filterInput = null;
          newItem.filterUpdate = newItem.filterUpdate + 1;
          return newItem;
        });
      }, 100);
      
    }
  }, []);

  const fetchAiResultList = async (options) => {
    const body = {
      paginationDto: {
        pageNumber: options.page,
        pageSize: 20,
        filterInput:
          options.filterObj.filterInput == null||
          options.filterObj.filterInput == ''
            ? null
            : options.filterObj.filterInput,
        destination:
            aiRequestsFilterObj.destination?.length > 0
              ? aiRequestsFilterObj.destination
              : null,
        clientNames:
            aiRequestsFilterObj.clientNames?.length > 0
              ? aiRequestsFilterObj.clientNames
              : null,
        patientId:
            aiRequestsFilterObj.patientId == null ||
            aiRequestsFilterObj.patientId == ''
              ? null
              : aiRequestsFilterObj.patientId,
        patientName:
            aiRequestsFilterObj.patientName == null ||
            aiRequestsFilterObj.patientName == ''
              ? null
              : aiRequestsFilterObj.patientName,
        status: status == null || status == undefined 
              ? [] 
              : status,
        jobId:
            aiRequestsFilterObj.jobId == null
              ? null
              : aiRequestsFilterObj.jobId,
        sendingStatus:
            aiRequestsFilterObj.sendingStatus == null
              ? null
              : aiRequestsFilterObj.sendingStatus,
        responseStatus:
            aiRequestsFilterObj.responseStatus == null
              ? null
              : aiRequestsFilterObj.responseStatus,
        fromDate:
            aiRequestsFilterObj.createdDateFrom == null ||
            aiRequestsFilterObj.createdDateFrom == ''
                ? null
                : aiRequestsFilterObj.createdDateFrom,
        toDate:
            aiRequestsFilterObj.createdDateTo == null ||
            aiRequestsFilterObj.createdDateTo == ''
                ? null
                : aiRequestsFilterObj.createdDateTo,  
      },
    };

    setLoaderRunning(true);
    ref.current.continuousStart();
    //setListViewLoading(true);
   // listViewRef.current.continuousStart();

    try {
      const response = await getAiRequestList(body);
      let data = null;
      let pageCount = null;
      if (response.status === 200 && response.data.result === "SUCCESS") {
        setLoaderRunning(false);
         ref.current.complete();
       // setListViewLoading(false);
        //listViewRef.current.complete();
        data = response.data.data.results.content;
        pageCount = response.data.data.results.totalPages;
        const responseData = response.data.data;
        if (responseData.clients) {
  const seen = new Set();
  const uniqueOptions = responseData.clients
    .map(c => ({ key: c.name, text: c.name }))
    .filter(o => seen.has(o.key) ? false : seen.add(o.key));
  setClientOptions(uniqueOptions);
}
if (responseData.destinations) {
  const seen = new Set();
  const uniqueOptions = responseData.destinations
    .map(d => ({ key: d.name, text: d.name }))
    .filter(o => seen.has(o.key) ? false : seen.add(o.key));
  setDestinationFilterOptions(uniqueOptions);
}
        return {
          rows: data,
          pageCount: pageCount,
        };
      } else {
        setLoaderRunning(false);
         ref.current.complete();
        //setListViewLoading(false);
        //listViewRef.current.complete();
        return {
          rows: data,
          pageCount: pageCount,
        };
      }
    } catch (e) {
      console.log(e);
      setLoaderRunning(false);
      ref.current.complete();
     // setListViewLoading(false);
    }
  };

  function ReloadList() {
    setFilterObj((prevFilterObj) => ({
      ...prevFilterObj,
      filterUpdate: prevFilterObj.filterUpdate + 1,
    }));
  }

  const handleExportInitiated = (progressId, token) => {
    setAiExportProgressId(progressId);
    setAiExportToken(token);
    setAiExportProgress(1);
  };

  const getFileName = (response) => {
    var disposition = response.headers["content-disposition"];
    var filename = "ai_export.csv";
    if (disposition && disposition.indexOf("attachment") !== -1) {
      var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      var matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, "");
      }
    }
    return filename;
  };

  const downloadAiExportFile = async (token) => {
    const response = await aiExportCsvDownloadFile(token);
    if (!response) {
      showToastv2(TOAST_TYPE.ERROR, "Error while downloading report.");
      return;
    }
    if (response.status === 200) {
      const file = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const url = window.URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", getFileName(response));
      document.body.appendChild(link);
      link.click();
      showToastv2(TOAST_TYPE.SUCCESS, "Export CSV downloaded");
      setAiExportProgress(101);
      link.remove();
    } else {
      showToastv2(TOAST_TYPE.ERROR, "Error while downloading report.");
    }
  };

const fetchAiExportProgress = async (interval, token) => {
    const response = await aiExportCsvFetchProgress(token);
    if (!response || !response.data || !response.data.data) {
      clearInterval(interval);
      showToastv2(TOAST_TYPE.ERROR, "Failed to fetch export progress.");
      return;
    }
    if (response.status === 200) {
      if (response.data.data.status === "FAILED") {
        hideProgress(aiExportProgressId);
        setAiExportProgress(0);
        showToastv2(
          TOAST_TYPE.ERROR,
          response.data.data.error
            ? response.data.data.error
            : "Failed to download file."
        );
        clearInterval(interval);
        return;
      }
      setAiExportProgress(response.data.data.progress);
    }
    return response.data.data.progress;
  };

  useEffect(() => {
    if (aiExportProgress === 0) return;

    if (aiExportProgress < 100) {
      updateProgress(aiExportProgressId, aiExportProgress);
      const oldProgress = aiExportProgress;
      const currentToken = aiExportToken;
      let progress;
      const interval = setInterval(async () => {
        progress = await fetchAiExportProgress(interval, currentToken);
        if (progress > oldProgress) {
          clearInterval(interval);
        }
      }, aiExportFetchInterval);
      aiExportPollIntervalRef.current = interval;
    }

    if (aiExportProgress === 100) {
      updateProgress(aiExportProgressId, aiExportProgress);
      downloadAiExportFile(aiExportToken);
    }

    if (aiExportProgress === 101) {
      updateProgress(aiExportProgressId, 100);
      setTimeout(() => {
        hideProgress(aiExportProgressId);
        setAiExportProgress(0);
      }, 3000);
    }

    return () => {
      if (aiExportPollIntervalRef.current) {
        clearInterval(aiExportPollIntervalRef.current);
      }
    };
  }, [aiExportProgress,aiExportToken]);

  const monthNames = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

  const formatBadgeDate = (ddmmyyyy, prefix) => {
    if (!ddmmyyyy) return null;
    const [d, m, y] = ddmmyyyy.split('/');
    return `${prefix}: ${d}-${monthNames[parseInt(m, 10) - 1]}-${y}`;
  };
  const handleApplyClick = (filterValue) => {
    if (filterValue != undefined) filterValue = filterValue.trim();
    const transformedArray = Object.keys(aiRequestsFilterObj)
      .map((key) => {
        let val = aiRequestsFilterObj[key];
        if (key === "sendingStatus") {
          val = getOptionText(sendingStatusOptions, val);
        }
        if (key === "responseStatus") {
          val = getOptionText(responseStatusOptions, val);
        }
        if (key === "createdDateFrom") {
        val = formatBadgeDate(val, "From");
        }
        if (key === "createdDateTo") {
          val = formatBadgeDate(val, "To");
        }
        if (key === "clientNames" && Array.isArray(val)) {
          return val.map(name => ({ key, label: name }));
        }
        if (key === "destination" && Array.isArray(val)) {
          return val.map(name => ({ key, label: name }));
        }
        return { key, label: val };
      })
      .flat().filter((item) => item.label !== null && item.label !== "");
    console.log('--- Handle Apply Click ---', transformedArray);

    setDisplayListAppliedFilter(transformedArray);

    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });
    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        if (filterValue != null) {
          newItem.filterInput = filterValue;
        }
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  const getOptionText = (options, key) => {
    const found = options.find((o) => o.key === key);
    return found ? found.text : key;
  };

  const filterList = (searchInput) => {
    console.log('--- Filter function TODO ---');
  };

  const handleClearFilter = () => {
    console.log('---- Clear Filter Clicked ----');
    setAiRequestsFilterObj(aiResultsInitialState);
    setDisplayListAppliedFilter([]);
    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });

    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterInput = null;
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  const removeBadgeFromFilter = (toBeRemoveObj) => {
    console.log('--- Updating RemoveBadgeFromFilter ----', toBeRemoveObj);
    setAiRequestsFilterObj((currentaiRequestsFilterObj) => {
      const updatedAiRequestsFilterObj = { ...currentaiRequestsFilterObj };

       if (updatedAiRequestsFilterObj.hasOwnProperty(toBeRemoveObj.key)) {
        const currentValue = currentaiRequestsFilterObj[toBeRemoveObj.key];
        updatedAiRequestsFilterObj[toBeRemoveObj.key] = Array.isArray(currentValue)
          ? currentValue.filter((item) => item !== toBeRemoveObj.label)
          : null;
      }
      return updatedAiRequestsFilterObj;
    });

    setDisplayListAppliedFilter((current) =>
      current.filter((item) => item.label !== toBeRemoveObj.label)
    );

    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });

    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  const columns = ColumnsAIRequest();

  const buttonsTopBar = [
    ...((roles?.[0] == USERTYPES.ADMIN ||
      (roles?.[0] == USERTYPES.FIRMADMIN ||
        roles?.[0] == USERTYPES.SUPERVISOR ||
        roles?.[0] == USERTYPES.FIRMDOCTOR ||
        roles?.[0] == USERTYPES.FIRMTECHNICIAN||
      roles?.[0] == USERTYPES.RADIOLOGIST))
      ? [{
          key: "export",
          button: (
            <PrimaryButton style={{ marginRight: "10px" }}
              text="Export CSV"
              className={"common-default-active-button list-view-top-buttons-styles"}
              onClick={() => setShowAiExportCsvModal(true)}
            />
          ),
        }]
      : []),
    {
      key: "1",
      button: (
        <PrimaryButton style={{ marginRight: "10px" }}
          text={t("button.refresh")}
          className={"common-default-active-button list-view-top-buttons-styles"}
          onClick={ReloadList}
        />
      ),
    },
  ];

  return (
    <>
      <AiExportCsvModal
        show={showAiExportCsvModal}
        onClose={() => setShowAiExportCsvModal(false)}
        aiRequestsFilterObj={aiRequestsFilterObj}
        filterInput={filterObj.filterInput}
        aiExportProgress={aiExportProgress}
        onExportInitiated={handleExportInitiated}
      />
      <ListViewV3
        buttonsTopBar={buttonsTopBar}
        sortDropdownOptions={[]}
        fetchData={fetchAiResultList}
        showSideBySide={false}
        columns={columns}
        handleUserClick={() => { console.log("clicked") }}
        filterObj={filterObj}
        setFilterObj={setFilterObj}
        // sortObj={sortObj}
        // setSortObj={setSortObj}
        setPagination={setPagination}
        handleApplyClick={handleApplyClick}
        paginationObj={paginationObj}
        unqiueKey={"AIRequests"}
        placeholder={t("placeholder.order-id-search")}
        //heading={t("navbar.pacs-queue")}
        tabHeaderPresent={true}
        pointer={false}
        fullLength={true}
        setDataQueryState={setDataQueryState}
        dataQueryState={dataQueryState}
        enhancedFilter={true}
        showSort={false}
        displayListAppliedFilter={displayListAppliedFilter}
        filterList={filterList}
        handleClearFilter={handleClearFilter}
        removeBadgeFromFilter={removeBadgeFromFilter}
        filterPopUpComponent={
          <FilterPopUpComponent
            aiRequestsFilterObj={aiRequestsFilterObj}
            setAiRequestsFilterObj={setAiRequestsFilterObj}
            clientOptions={clientOptions}
            destinationFilterOptions={destinationFilterOptions}
          />
        }
        //listViewLoading={listViewLoading}
        //listViewRef={listViewRef}
        //setListViewLoading={setListViewLoading}
      />

    </>
  );
};

export default AIRequestList;

const FilterPopUpComponent = ({
  aiRequestsFilterObj,
  setAiRequestsFilterObj,
  clientOptions,
  destinationFilterOptions,
}) => {
  return (
    <div style={{ display: 'flex', marginBottom: '10px' }}>
      <div
        className="study-start-date-filter-section align-filter-section"
        style={{ width: '15%' }}
      >
        <span className="filter-section-text">
          Patient ID
        </span>
        <TextField
          name="Patient Id"
          placeholder={t('placeholder.search')}
          value={aiRequestsFilterObj.patientId}
          onChange={(ev) => {
            setAiRequestsFilterObj({
              ...aiRequestsFilterObj,
              patientId: ev.target.value,
            });
          }}
          styles={{ backgroundColor: '#2e3033' }}
        />
        <span className="filter-section-text" style={{marginTop : "5px"}}>
          Patient Name
        </span>
        <TextField
          name="Patient Name"
          placeholder={t('placeholder.search')}
          value={aiRequestsFilterObj.patientName}
          onChange={(ev) => {
            setAiRequestsFilterObj({
              ...aiRequestsFilterObj,
              patientName: ev.target.value,
            });
          }}
          styles={{  fieldGroup: { 
          height: '32px',
          display: 'block',
          
          },
          field: {
          paddingTop: '6px',
            
             }
           }}
           
        />
      </div>

      <div className="filter-section-seperator"></div>

      <div
        className="study-start-date-filter-section align-filter-section"
        style={{ width: '15%' }}
      >
        
        <span className="filter-section-text">
          Destination
        </span>
        <CustomMultiSelect
          options={destinationFilterOptions}
          placeholder="Select destinations"
          searchPlaceholder="Search destinations"
          selectedKeys={aiRequestsFilterObj.destination || []}
          setSelectedKeys={(keys) => {
            setAiRequestsFilterObj({
              ...aiRequestsFilterObj,
              destination: keys || [],
            });
          }}
          showSelectAll={true}
          calloutProps={{ doNotLayer: true }}
        />
        <span className="filter-section-text" style={{marginTop : "5px"}}>
          Job Id
        </span>
        <TextField
          name="Job Id"
          placeholder={t('placeholder.search')}
          value={aiRequestsFilterObj.jobId}
          onChange={(ev) => {
            setAiRequestsFilterObj({
              ...aiRequestsFilterObj,
              jobId: ev.target.value,
            });
          }}
          styles={{ backgroundColor: '#2e3033' }}
        />
      </div>

      <div className="filter-section-seperator"></div>

      <div
        className="study-start-date-filter-section align-filter-section"
        style={{ width: '15%' }}
      >
        
        <span className="filter-section-text">
          Sending Status
        </span>
        <Dropdown
          placeholder="Select status"
          options={sendingStatusOptions}
          selectedKey={aiRequestsFilterObj.sendingStatus}
          onChange={(event, option) => {
            setAiRequestsFilterObj({
              ...aiRequestsFilterObj,
              sendingStatus: option.key,
            });
          }}
          calloutProps={{ doNotLayer: true }}
          styles={{ 
            root: { marginTop: 0 },
            title: { marginBottom: 0 } 
            // dropdown: { backgroundColor: '#2e3033' } 
          }}
        />
        <span className="filter-section-text" style={{marginTop : "5px"}}>
          Response Status
        </span>
        <Dropdown
          placeholder="Select response"
          options={responseStatusOptions}
          selectedKey={aiRequestsFilterObj.responseStatus}
          onChange={(event, option) => {
            setAiRequestsFilterObj({
              ...aiRequestsFilterObj,
              responseStatus: option.key,
            });
          }}
          calloutProps={{ doNotLayer: true }}
        />
      </div>

      <div className="filter-section-seperator"></div>

      <div
          className="study-start-date-filter-section align-filter-section"
          style={{ width: '15%' }}
        >
         <span className="filter-section-text">
            Request Created From
          </span>
          <DatePicker
            placeholder="Select date"
            formatDate={(date) => {
              const monthNames = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
              return `${String(date.getDate()).padStart(2, '0')}-${monthNames[date.getMonth()]}-${date.getFullYear()}`;
            }}
            value={aiRequestsFilterObj.createdDateFrom
                    ? (() => {
                        const [d, m, y] = aiRequestsFilterObj.createdDateFrom.split('/');
                        return new Date(y, m - 1, d);
                      })()
                    : null}
            onSelectDate={(date) => {
              const formatted = date
                ? `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`
                : null;
              setAiRequestsFilterObj({
                ...aiRequestsFilterObj,
                createdDateFrom: formatted,
              });
            }}
            calloutProps={{ doNotLayer: true }}
          />
          <span className="filter-section-text" style={{ marginTop: "5px" }}>
            Request Created To
          </span>
          <DatePicker
            placeholder="Select date"
             formatDate={(date) => {
                const monthNames = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
                return `${String(date.getDate()).padStart(2, '0')}-${monthNames[date.getMonth()]}-${date.getFullYear()}`;
              }}
            value={aiRequestsFilterObj.createdDateTo
                    ? (() => {
                        const [d, m, y] = aiRequestsFilterObj.createdDateTo.split('/');
                        return new Date(y, m - 1, d);
                      })()
                    : null}
            onSelectDate={(date) => {
              const formatted = date
                ? `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`
                : null;
              setAiRequestsFilterObj({
                ...aiRequestsFilterObj,
                createdDateTo: formatted,
              });
            }}
            calloutProps={{ doNotLayer: true }}
          />
        </div>

      <div className="filter-section-seperator"></div>

      <div
        className="study-start-date-filter-section align-filter-section"
        style={{ width: '15%' }}
      >
        <span className="filter-section-text">
          Clients
        </span>
        <CustomMultiSelect
          options={clientOptions}
          placeholder="Select clients"
          searchPlaceholder="Search clients"
          selectedKeys={aiRequestsFilterObj.clientNames || []}
          setSelectedKeys={(keys) => {
            setAiRequestsFilterObj({
              ...aiRequestsFilterObj,
              clientNames: keys || [],
            });
          }}
          showSelectAll={true}
          calloutProps={{ doNotLayer: true }}
        />
      </div>
    </div>
  );
};
